import type { FC } from "react";

import { ColoredLabel, type TagIntent } from "widgets";

import type { IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import { getTagIntentColor } from "@/app-utils/events.js";
import { toTitleCase } from "@/app-utils/string.ts";
import type { JobStatusEnum } from "@/graphql.js";
import { matchStatusToTagIntent } from "@/modules/jobs/utils/statusToTag.ts";

const JobStatusCell: FC<IAgGridCellProps> = (props) => {
  const jobStatus = props.value as JobStatusEnum;

  if (jobStatus == null) {
    return null;
  }

  return (
    <TableCell>
      <ColoredLabel
        color={getTagIntentColor(matchStatusToTagIntent(jobStatus).intentColor as TagIntent)}
        label={toTitleCase(jobStatus)}
      />
    </TableCell>
  );
};

export default JobStatusCell;
